const orientation = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};

export default orientation;
